import { render } from "./indexUserScore.vue?vue&type=template&id=5662a029&scoped=true"
import script from "./indexUserScore.vue?vue&type=script&lang=js"
export * from "./indexUserScore.vue?vue&type=script&lang=js"

import "./indexUserScore.vue?vue&type=style&index=0&id=5662a029&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5662a029"]])

export default __exports__